import { mdiSwapHorizontal } from '@mdi/js'
import Icon from '@mdi/react'

import { Container } from '@/components/ui/container'
import { Flex } from '@/components/ui/flex'
import { Separator } from '@/components/ui/separator'
import { Text } from '@/components/ui/typography'
import { IShortMessageObject } from '@/types/gigiChat/Chat'

const FakeServerMessage = ({ item }: { item: IShortMessageObject }) => {
    return (
        <>
            <Flex w="100%" direction="column" data-testid="chat-custom-message">
                {item.fakeServerMessage?.title && (
                    <Flex direction="row" alignItems="center">
                        <Icon path={mdiSwapHorizontal} size={0.8} color="var(--chakra-colors-gray-600)" />
                        <Text
                            data-testid="chat-custom-message-title"
                            as="p"
                            fontSize="12px"
                            opacity="0.7"
                            pl="8px"
                            pr="8px"
                            whiteSpace="nowrap"
                        >
                            {item.fakeServerMessage.title}
                        </Text>
                        <Separator flexGrow={1} />
                    </Flex>
                )}
                <Container maxW="unset" my="1" variant="server">
                    <Text data-testid="chat-custom-message-text" lineHeight="20px" fontSize="14px" as="div">
                        {item.fakeServerMessage?.message}
                    </Text>
                </Container>
            </Flex>
        </>
    )
}

export default FakeServerMessage
